export const Section1 = {
	heading: 'Stand Out at Newtopia Now 2025 with Beacon Discovery',
	content1:
		'. If you’re gearing up to showcase your brand, Beacon Discovery is the best place to get a head start on connections this summer.',
	content2:
		' to find standout brands worth connecting with. If you want to catch their eye, now’s the time to fine-tune your profile and make sure your products are front and center. Beacon Discovery access for your brand is included with booth costs, and you won’t want to miss out on this exhibitor benefit.',
	content3: 'Here’s how to get the most out of your Beacon Discovery presence:'
};

export const Section2 = {
	heading: 'Refresh Your Brand Profile',
	content1: {
		heading:
			'Your Beacon Discovery profile may be the first impression retailers get of your brand. Make sure it’s a good one! Here’s some things to check:',
		subcontent: {
			content1: 'Is your brand story clear and compelling?',
			content2: 'Have you updated your logo, contact info, and HQ location?',
			content3: 'Are your website and social media links live and accurate?',
			content4: 'Is your distribution information current? Is Private Label available?'
		}
	},
	content2:
		'With your Beacon Hub, you can quickly update all of this in one place. Look from the eyes of a retailer and ask, does my profile have the information they need to make an informed buying decision?'
};

export const Section3 = {
	heading: 'Make Your Products Pop',
	content1: {
		subcontent: {
			heading:
				'Newtopia Now gives retailers a snapshot of what’s fresh, exciting, and ready for shelves. Make sure your product listings reflect your latest and greatest:',
			content1: {
				boldcontent: 'Highlight new products: ',
				content:
					'Launched something recently? Make sure retailers can find it under the “New to Beacon” filter.'
			},
			content2: {
				boldcontent: 'Upgrade your visuals: ',
				content:
					'High-res photos mean Beacon Discovery can pull key attribute information about your product, ensuring you come up when retailers are filtering to find the products that match their criteria.'
			},
			content3: {
				boldcontent: 'Declutter: ',
				content: 'Remove discontinued SKUs to avoid confusion.'
			}
		}
	},
	content2:
		'If you need to upload new products or make changes to existing SKUs, contact the Audience Success Team for assistance.'
};

export const Section4 = {
	heading: 'Elevate Trust with MarketReady Verified',
	content1:
		'Retailers want to know you’re ready for the real world, and on Beacon, nothing signals that better than the ',
	content2:
		'to ensure your label meets FDA standards. It’s a badge of compliance and credibility that can give retailers added confidence in your products.'
};

export const Section5 = {
	heading: 'Get Started Now',
	content1:
		'Don’t wait, upload and update your Beacon Discovery presence today and beat the pre-show rush.',
	content2:
		'Whether this is your first time at Newtopia Now or you’re a returning favorite, having a strong Beacon Discovery presence helps you make connections before you even land in Colorado. Retailers and other attendees are already browsing. Make sure your brand is one they don’t miss.'
};

export enum Links {
	newtopia = 'https://www.newtopianow.com/en/home.html',
	beacon_discovery = 'https://beacon.newhope.com/',
	market_ready = 'https://marketreadyinsights.com/marketready-verified/',
	market_ready_insights = 'https://marketreadyinsights.com/',
	bone_suckin = 'https://beaconapp.newhope.com/brand/1728500090_6706d17a4c1880.49509452'
}

export enum Images {
	update_brand = 'https://s44021.pcdn.co/wp-content/uploads/2025/01/Brand-1.png',
	market_ready = 'https://s44021.pcdn.co/wp-content/uploads/2023/05/MarketReady-logo.png',
	mustard = 'https://s44021.pcdn.co/wp-content/uploads/2025/04/79e930dc5d0f5b75c95c73c8998481c5-300x300.jpg',
	wings = 'https://s44021.pcdn.co/wp-content/uploads/2025/04/5889a4ccf6a53713d56b440ce14ca2d9-300x300.jpg',
	wings_description = 'https://s44021.pcdn.co/wp-content/uploads/2025/04/4530fb338ed686ab73204a54c7e3eb13-300x300.jpg'
}
